//#region Libraries
import styled from "styled-components";
//#endregion

export const Container = styled.div`
    padding: 10px 30px;
    display: flex;
    flex-direction: column;
    gap: 8px;
`;
export const StyledHeader = styled.header`
    display: flex;
    flex-direction: column;
    gap: 5px;
    padding: 10px 30px;
`;